<ng-template #nonpayerDialog>
    <h1 mat-dialog-title>IMPORTANT</h1>
    <div mat-dialog-content style="font-weight:400">
        <p class="gs1-little" >Afin de continuer à utiliser CodeOnline, nous vous invitons à solder toute facture d’abonnement non réglée.</p>

        <p class="gs1-little">Sans cela, à compter du 04/03/24, vous ne pourrez plus accéder à CodeOnline pour codifier vos lieux.</p>
            
        <p class="gs1-little"> Si vous avez déjà fait le nécessaire, merci de ne pas tenir compte de ce message.</p>
        <gs1-checkbox [name]="'dontshow'" [(ngModel)]="dontshow">
          <label for="dontshow">Ne plus afficher. </label>
        </gs1-checkbox>
    </div>
    <div mat-dialog-actions>
        <button gs1Button [pending]="updating"  [thin]="true" (click)="closeDialog()">Fermer</button>
        <button gs1Button  [thin]="true" (click)="GoToEcli()">Accéder à mes factures</button>
    </div>
  </ng-template>
  